{{!-- graph --}}
<g clip-path="url(#coordinate_system)">
{{#each plotData.polylines}}
<polyline id="js-polyline-{{type}}" class="js-polyline{{#if inactive}} disabled-plotline{{/if}}"
	points="{{points}}"
	fill="none" stroke="{{color}}" stroke-width="{{../plotData.strokeWidth}}" stroke-dasharray="{{../plotData.dashstyle}}"/>
{{/each}}
</g>

{{!-- data-points for dragging --}}
{{#unless readOnly}}
	{{#each dragPoints}}
	<circle id="js-point-{{@index}}" class="js-point draggable" r="15" cx="{{x}}" cy="{{y}}" fill="{{../color}}" stroke="none" />
	{{/each}}

	{{!-- contains all elements used for dragging, e.g. moving labels and helplines--}}
	<g id="drag-visualization" class="invisible" fill="red" stroke="red">
		{{!-- help-lines--}}
		<line id="js-horizontal-help-line"
			x1="50" y1="{{horizontal.line.y}}" x2="{{horizontal.line.x2}}" y2="{{horizontal.line.y}}"
			 stroke-width="5" stroke-dasharray="50 50"/>

		<line id="js-vertical-help-line"
			x1="{{vertical.line.x}}" y1="1450" x2="{{vertical.line.x}}" y2="{{vertical.line.y2}}"
			stroke-width="5" stroke-dasharray="50 50"/>
		<rect id="x-help-background" x="{{CALCULATE vertical.line.x '-' 80}}" y="1450" width="160" height="60" fill="white" stroke="none"></rect>
		<rect id="y-help-background" x="-100" y="{{CALCULATE horizontal.line.y '-' 25}}" width="160" height="60" fill="white" stroke="none"></rect>

		<text id="js-horizontal-label" x="40" y="{{horizontal.label.y}}" font-size="50" text-anchor="end">
			{{horizontal.label.value}} °C
		</text>
		<text id="js-vertical-label" x="{{vertical.label.x}}" y="1500" font-size="50" text-anchor="middle">
			{{vertical.label.value}} °C
		</text>
	</g>
{{/unless}}
